import * as ActionTypes from './action.js';

export const INITIALIZE_STATE = {
    cartList: [], // 购物车列表
}

const reducerMap = {
    // 编辑参数
    [ActionTypes.EDIT_PARAM]: (state, payload) => {
        return Object.assign({}, state, payload);
    },
}


export default (state = INITIALIZE_STATE, action = {}) => {
    const { type, payload } = action;
    const reducer = reducerMap[type];
    if (reducer) {
        return reducer(state, payload);
    } else {
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/check_beyond_level/reducer.js